import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { isUserLogin } from '@eureka/utils/account';

export interface DrugInfo {
    pn: string
    title: string
    current_assignee: {
        lang: 'CN' | 'EN'
        ans_id: string
        name: string
        organization: {
            display_name_cn?: string
            display_name_en: string
            entity_id: string
        }
    }[]
    patent_id: string
    simple_legal_status: string
    abst: string
    country: string
}

export interface DrugApi {
    getDrugInfo(data: {drug_ids: string[]}): Promise<Record<string, DrugInfo>>;
}

export const DrugApi = Symbol('DrugApi');

@injectable()
export class DrugApiImpl extends PsHttpService implements DrugApi {
    get baseUrl() {
        return `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`
    }

    get options() {
        return {
            baseURL: this.baseUrl,
        };
    }

    async getDrugInfo(data: {drug_ids: string[]}) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/guest'
        return this.post<PatSnapCommonResponseData<Record<string, DrugInfo>>>({
            url: `${base}/drug/batch_card`,
            data,
        }).then((res) => {
            return res as unknown as Record<string, DrugInfo>;
        });
    }
}
